// extracted by mini-css-extract-plugin
export default {"fullWidth":"styles_fullWidth__JxpLT","error":"styles_error__dJShU"};